module.exports = __webpack_public_path__ + "img/img_no2.1b57696b.png";